/**
 * Shape Type Enum
 *
 * Defines the available polygon shape types for geometric representations.
 *
 * @enum {string}
 */
export enum ShapeType {
  /**
   * Four-sided rectangular polygon
   * Defined by bounding box coordinates
   */
  Rectangle = 'Rectangle',

  /**
   * Circular polygon (64 vertices)
   * Defined by center point and radius
   */
  Circle = 'Circle',

  /**
   * Three-sided triangular polygon
   * Defined by three vertex coordinates
   */
  Triangle = 'Triangle',

  /**
   * Generic closed polygon with N vertices (N ≥ 3).
   * Used for legacy shapes persisted before Rectangle/Triangle/Circle
   * specialisations existed and for free-form polygons.
   */
  Polygon = 'Polygon',
}
